// extracted by mini-css-extract-plugin
module.exports = {"doc-page-wrapper":"x_bD container-lg d-flex p-3","doc-page":"x_bF","doc-page__title--enterprise":"x_bG","doc-page--with-side-menu":"x_bH","doc-page__title":"x_bJ"};